import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { getIosModalPresentationConfig, ModalDialogue, useResponsive } from '@sg/garnish';

import { LoadingAnimation } from '../LoadingAnimation';
import { AccountDeletionSecondStep } from './components';
import { useAccountDeletion, useAccountDeletionContentfulData } from './hooks';

export const RequestAccountDeletionModal = (props: RequestAccountDeletionModalProps) => {
  const { visible, onClose, onSuccess } = props;

  const { match } = useResponsive();
  const { formatMessage } = useIntl();

  const { body, isLoadingContentfulData } = useAccountDeletionContentfulData();

  const { isDeletingAccount, requestAccountDeletion } = useAccountDeletion({
    onClose,
    onSuccess,
  });

  return (
    <ModalDialogue
      size={match(['full', 'medium'])}
      accessibilityLabel={formatMessage(messages.accountDeleteHeadline)}
      visible={visible}
      onRequestClose={onClose}
      fitHeight
      {...getIosModalPresentationConfig()}
    >
      {isLoadingContentfulData ? (
        <LoadingAnimation />
      ) : (
        <AccountDeletionSecondStep
          body={body}
          isDeletingAccount={isDeletingAccount}
          requestAccountDeletion={requestAccountDeletion}
        />
      )}
    </ModalDialogue>
  );
};

type RequestAccountDeletionModalProps = Readonly<{
  visible: boolean;
  onSuccess: () => void;
  onClose: () => void;
}>;

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  accountDeleteHeadline: {
    defaultMessage: 'Delete account',
    description: 'Account | Delete | Headline',
  },
});
